import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ContractTemplate } from 'components/Templates'

const Contract: FC = () => {
  return (
    <Layout headline={'契約情報'} title={'契約情報'}>
      <ContractTemplate />
    </Layout>
  )
}

export default Contract
